@if (authService.isAuthenticatedAndAgreed()) {
  <div id="side-nav" class="d-flex flex-column" [class.collapsed]="sideNavService.navCollapsed | async">
    <nav class="d-flex flex-grow-1">
      @if (!patientNav?.length && !adminHubNav?.length) {
        <button
          id="collapse-nav-toggle"
          type="button"
          class="btn btn-primary btn-sm rounded-circle"
          [ngbTooltip]="((sideNavService.navCollapsed | async) ? 'Expand' : 'Collapse') + ' nav'"
          placement="right"
          (click)="sideNavService.toggleNavCollapsed()"
        >
          <i
            [ngClass]="{
              fas: true,
              'fa-fw': true,
              'fa-chevron-right': (sideNavService.navCollapsed | async),
              'fa-chevron-left': (sideNavService.navCollapsed | async) === false
            }"
          ></i>
        </button>
      }
      <ul
        class="list-unstyled primary-nav"
        [class.collapsed]="(sideNavService.navCollapsed | async) || showPatientNav || showAdminHubNav"
        (mouseenter)="onPrimaryNavMouseEnter()"
        (mouseleave)="onPrimaryNavMouseLeave()"
      >
        <li>
          <a
            [id]="links.myDashboard.id"
            routerLink="{{ authService.roleDashboardUrl }}"
            routerLinkActive="active"
            [title]="links.myDashboard.title"
            [ngbTooltip]="links.myDashboard.title"
            [disableTooltip]="(sideNavService.navCollapsed | async) === false"
            placement="right"
            ><i class="fas fa-tachometer-alt"></i><span>{{ links.myDashboard.title }}</span></a
          >
        </li>
        @if (authService.isEntitled('/worklist/getWorklistJsonDetails.html')) {
          <li>
            <a
              [id]="links.myWorklists.id"
              routerLink="/private/my-worklist"
              routerLinkActive="active"
              [title]="links.myWorklists.title"
              [ngbTooltip]="links.myWorklists.title"
              [disableTooltip]="(sideNavService.navCollapsed | async) === false"
              placement="right"
              ><i class="fas fa-tasks"></i><span>{{ links.myWorklists.title }}</span></a
            >
          </li>
        }
        @if (
          authService.isEntitled('/patients/searchAssociatedPatients.html') &&
          !authService.isEntitled('/patients/hideAssociatedPatients.html')
        ) {
          <li>
            <a
              [id]="links.associatedPatients.id"
              routerLink="/private/associated-patients"
              routerLinkActive="active"
              [title]="links.associatedPatients.title"
              [ngbTooltip]="links.associatedPatients.title"
              [disableTooltip]="(sideNavService.navCollapsed | async) === false"
              placement="right"
              ><i class="fas fa-search-plus"></i><span>{{ links.associatedPatients.title }}</span></a
            >
          </li>
        }
        @if (
          authService.isEntitled('/dashboard/diseaseManagement.html') &&
          (!authService.isUserRoleExternalAgency || authService.user.sudSmiProgramDashboardAccess)
        ) {
          <li>
            <a
              [id]="links.dmDashboard.id"
              routerLink="/private/programs-dashboard"
              routerLinkActive="active"
              [title]="links.dmDashboard.title"
              [ngbTooltip]="links.dmDashboard.title"
              [disableTooltip]="(sideNavService.navCollapsed | async) === false"
              placement="right"
              ><i class="far fa-list-alt"></i><span>{{ links.dmDashboard.title }}</span></a
            >
          </li>
        }
        @if (authService.isEntitled('/patients/viewPatients.html')) {
          <li>
            <a
              [id]="links.searchMembers.id"
              routerLink="/private/patient-search"
              routerLinkActive="active"
              [title]="links.searchMembers.title"
              [ngbTooltip]="links.searchMembers.title"
              [disableTooltip]="(sideNavService.navCollapsed | async) === false"
              placement="right"
              ><i class="fas fa-search"></i><span>{{ links.searchMembers.title }}</span></a
            >
          </li>
        }
        @if (authService.isEntitled('/patients/displayBulkAssignPatient.html')) {
          <li>
            <a
              [id]="links.bulkAssignMembers.id"
              routerLink="/private/patient-bulk-assign"
              routerLinkActive="active"
              [title]="links.bulkAssignMembers.title"
              [ngbTooltip]="links.bulkAssignMembers.title"
              [disableTooltip]="(sideNavService.navCollapsed | async) === false"
              placement="right"
              ><i class="fas fa-search"></i><span>{{ links.bulkAssignMembers.title }}</span></a
            >
          </li>
        }
        @if (authService.isEntitled('/patients/saveManualPatientEntry.html')) {
          <li>
            <a
              [id]="links.manualPatientEntry.id"
              routerLink="/private/add-edit-manual-patient-entry"
              routerLinkActive="active"
              [title]="links.manualPatientEntry.title"
              [ngbTooltip]="links.manualPatientEntry.title"
              [disableTooltip]="(sideNavService.navCollapsed | async) === false"
              placement="right"
              ><i class="fas fa-user-plus"></i><span>{{ links.manualPatientEntry.title }}</span></a
            >
          </li>
        }
        @if (authService.isEntitled('/sftp/medical-homes/permissioned.html')) {
          <li>
            <a
              [id]="links.reports.id"
              routerLink="/private/report-files"
              routerLinkActive="active"
              [title]="links.reports.title"
              [ngbTooltip]="links.reports.title"
              [disableTooltip]="(sideNavService.navCollapsed | async) === false"
              placement="right"
              ><i class="fas fa-file-export"></i><span>{{ links.reports.title }}</span></a
            >
          </li>
        }
        @if (authService.isEntitled('/resource/getResourceSummary.html')) {
          <li>
            <a
              [id]="links.resources.id"
              routerLink="/private/resources"
              routerLinkActive="active"
              [title]="links.resources.title"
              [ngbTooltip]="links.resources.title"
              [disableTooltip]="(sideNavService.navCollapsed | async) === false"
              placement="right"
              ><i class="fas fa-book"></i><span>{{ links.resources.title }}</span></a
            >
          </li>
        }
        @if (authService.isEntitled('/users/viewIndividualUsers.html')) {
          <li class="border-bottom"></li>
          <li>
            <a
              [id]="links.adminHub.id"
              routerLink="/private/admin-hub/users/search"
              routerLinkActive="active"
              [title]="links.adminHub.title"
              [ngbTooltip]="links.adminHub.title"
              [disableTooltip]="(sideNavService.navCollapsed | async) === false"
              placement="right"
              ><i class="fas fa-folder-open"></i><span>{{ links.adminHub.title }}</span></a
            >
          </li>
        }
        <li class="border-bottom"></li>
        @if (externalNavItems?.length) {
          @for (externalNavItem of externalNavItems; track externalNavItem) {
            <li>
              <a
                [href]="externalNavItem.url"
                target="_blank"
                [title]="externalNavItem.text"
                [ngbTooltip]="externalNavItem.text"
                [disableTooltip]="(sideNavService.navCollapsed | async) === false"
                placement="right"
                ><i class="fas fa-external-link-alt"></i><span>{{ externalNavItem.text }}</span></a
              >
            </li>
          }
          <li class="border-bottom"></li>
        }
        <li>
          <a
            [id]="links.notifications.id"
            routerLink="/private/notifications"
            routerLinkActive="active"
            [title]="links.notifications.title"
            [ngbTooltip]="links.notifications.title"
            [disableTooltip]="(sideNavService.navCollapsed | async) === false"
            placement="right"
            ><i class="fas fa-bullhorn"></i><span>{{ links.notifications.title }}</span>
            <th-unread-notification-count
              [hideText]="showAdminHubNav || showPatientNav || (sideNavService.navCollapsed | async)"
            ></th-unread-notification-count>
          </a>
        </li>
        @if (
          authService.isEntitled('/patients/fetchuserSentMessages.html') &&
          authService.isEntitled('/patients/fetchuserReceiveMessages.html')
        ) {
          <li>
            <a
              [id]="links.messenger.id"
              routerLink="/private/messages"
              routerLinkActive="active"
              [title]="links.messenger.title"
              [ngbTooltip]="links.messenger.title"
              [disableTooltip]="(sideNavService.navCollapsed | async) === false"
              placement="right"
            >
              <i class="far fa-comment"></i><span>{{ links.messenger.title }}</span>
              <th-unread-message-count
                [hideText]="showAdminHubNav || showPatientNav || (sideNavService.navCollapsed | async)"
              ></th-unread-message-count>
            </a>
          </li>
        }
        <li>
          <a
            [id]="links.support.id"
            routerLink="/private/support-ticket"
            routerLinkActive="active"
            [title]="links.support.title"
            [ngbTooltip]="links.support.title"
            [disableTooltip]="(sideNavService.navCollapsed | async) === false"
            placement="right"
            ><i class="far fa-question-circle"></i><span>{{ links.support.title }}</span></a
          >
        </li>
        @if (authService.isEntitled('/new-user-request/upsert') && authService?.user?.asmStatus) {
          <li>
            <a
              [id]="links.requestNewMHNConnectUser.id"
              routerLink="/private/request-new-mhnconnect-user"
              routerLinkActive="active"
              [title]="links.requestNewMHNConnectUser.title"
              [ngbTooltip]="links.requestNewMHNConnectUser.title"
              [disableTooltip]="(sideNavService.navCollapsed | async) === false"
              placement="right"
              ><i class="fas fa-user-plus"></i><span>{{ links.requestNewMHNConnectUser.title }}</span></a
            >
          </li>
        }
        @if (authService.isEntitled('/users/updateMyUserProfile.html')) {
          <li>
            <a
              [id]="links.updateProfile.id"
              [title]="links.updateProfile.title"
              (click)="openModal(editProfile)"
              [ngbTooltip]="links.updateProfile.title"
              [disableTooltip]="(sideNavService.navCollapsed | async) === false"
              placement="right"
              href="javascript:"
              ><i class="fas fa-user-edit"></i><span>{{ links.updateProfile.title }}</span></a
            >
          </li>
        }
        @if (authService.isEntitled('/feedback/addFeedback.html')) {
          <li>
            <a
              [id]="links.userFeedback.id"
              [title]="links.userFeedback.title"
              (click)="openModal(userFeedback)"
              [ngbTooltip]="links.userFeedback.title"
              [disableTooltip]="(sideNavService.navCollapsed | async) === false"
              placement="right"
              href="javascript:"
              ><i class="fas fa-comment-alt"></i><span>{{ links.userFeedback.title }}</span></a
            >
          </li>
        }
        @if (authService.isEntitled('/members/duplicateMemberData.html')) {
          <li>
            <a
              [id]="links.duplicateMembers.id"
              routerLink="/private/duplicate-members"
              routerLinkActive="active"
              [title]="links.duplicateMembers.title"
              [ngbTooltip]="links.duplicateMembers.title"
              [disableTooltip]="(sideNavService.navCollapsed | async) === false"
              placement="right"
              ><i class="fa fa-address-card"></i><span>{{ links.duplicateMembers.title }}</span></a
            >
          </li>
        }
        @if (authService.isEntitled('/users/viewSystemTest.html')) {
          <li>
            <a
              [id]="links.systemTest.id"
              routerLink="/private/system-test"
              routerLinkActive="active"
              [title]="links.systemTest.title"
              [ngbTooltip]="links.systemTest.title"
              [disableTooltip]="(sideNavService.navCollapsed | async) === false"
              placement="right"
              ><i class="fas fa-check"></i><span>{{ links.systemTest.title }}</span></a
            >
          </li>
        }
        <li class="border-bottom">
          <a
            [id]="links.logout.id"
            routerLink="/logout"
            routerLinkActive="active"
            [title]="links.logout.title"
            [ngbTooltip]="links.logout.title"
            [disableTooltip]="(sideNavService.navCollapsed | async) === false"
            placement="right"
            ><i class="fas fa-sign-out-alt"></i><span>{{ links.logout.title }}</span></a
          >
        </li>
        <li class="info-only fw-bold">{{ authService.user.firstName }} {{ authService.user.lastName }}</li>
        <li class="info-only">{{ authService.timezone }}</li>
      </ul>
      @if (showPatientNav) {
        <ul class="list-unstyled secondary-nav">
          @for (navItem of patientNav; track navItem) {
            @if (isEntitled(navItem)) {
              <li>
                @if (!navItem.external) {
                  <a
                    [id]="navItem.id"
                    [routerLink]="[navItem.routerLink]"
                    (click)="updateHeaderText(navItem)"
                    routerLinkActive="active"
                    [title]="navItem.displayText"
                    [ngbTooltip]="navItem.displayText"
                    [disableTooltip]="(sideNavService.navCollapsed | async) === false"
                    placement="right"
                    ><span>{{ navItem.displayText }}</span></a
                  >
                }
                @if (navItem.external) {
                  <a
                    [href]="navItem.routerLink"
                    target="_blank"
                    [title]="navItem.displayText"
                    [ngbTooltip]="navItem.displayText"
                    [disableTooltip]="(sideNavService.navCollapsed | async) === false"
                    placement="right"
                    [ngbTooltip]="navItem.displayText"
                    ><span>{{ navItem.displayText }}</span></a
                  >
                }
              </li>
            }
          }
        </ul>
      }
      @if (showAdminHubNav) {
        <ul class="list-unstyled secondary-nav">
          @for (navItem of adminHubNav; track navItem) {
            @if (isEntitled(navItem)) {
              <li>
                <a
                  [id]="navItem.id"
                  [routerLink]="[navItem.routerLink]"
                  (click)="updateHeaderText(navItem)"
                  routerLinkActive="active"
                  [title]="navItem.displayText"
                  [ngbTooltip]="navItem.displayText"
                  [disableTooltip]="(sideNavService.navCollapsed | async) === false"
                  placement="right"
                  ><span>{{ navItem.displayText }}</span></a
                >
              </li>
            }
          }
        </ul>
      }
    </nav>
    <ng-template #editProfile let-modal>
      <th-edit-my-profile></th-edit-my-profile>
    </ng-template>
    <ng-template #userFeedback let-modal>
      <div class="modal-body">
        <th-feedback></th-feedback>
      </div>
    </ng-template>
  </div>
}
